<template>
  <!-- Client or partition logo; without one, an organisation tile: a building for a client, layers for a partition (US 9372) -->
  <span class="ws-avatar"
        :class="{ 'ws-avatar--partition': isPartition, 'ws-avatar--logo': !!ws.logo }"
        :style="{ width: size + 'px', height: size + 'px', fontSize: Math.round(size * 0.46) + 'px' }"
        :title="ws.name"
  >
    <img v-if="ws.logo" :src="ws.logo" alt="">
    <font-awesome-icon v-else :icon="isPartition ? 'layer-group' : 'building'"/>
  </span>
</template>

<script>
export default {
  name: 'WorkspaceAvatar',
  props: {
    // While the app starts, the store holds the client as its slug only
    workspace: {
      type: [Object, String],
      required: true
    },
    size: {
      type: Number,
      default: 28
    },
    // Set when the caller knows; otherwise worked out from the workspace's parent
    partition: {
      type: Boolean,
      default: null
    }
  },
  computed: {
    ws() {
      return typeof this.workspace === 'string' ? { slug: this.workspace } : (this.workspace || {});
    },
    isPartition() {
      if (this.partition !== null) {
        return this.partition;
      }
      return !!this.ws.parent || !!this.ws.parent_id;
    }
  }
}
</script>
